import { DevelopmentModule } from './modules/development/development.module';
import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

import { AccessDeniedComponent } from './modules/navigation/access-denied/access-denied.component';
import { AccessMailRevalidateComponent } from './modules/navigation/access-mail-revalidate/access-mail-revalidate.component';
import { NotFoundComponent } from './modules/navigation/not-found/not-found.component';

import { AppBaseComponent } from './app-base.component';
import { TokenSetupResolver as TokenAndSetupResolver } from './core/services/token-setup.resolver';

import { PolicyGuard } from './core/services/policy.guard';
import { RedirectTokenComponent, SharedDetailNewsComponent } from './@theme/components';
import { OAuthComponent } from './modules/auth/components/o-auth/o-auth.component';

const routes: Routes = [
    {
        path: '',
        component: AppBaseComponent,
        resolve: { data: TokenAndSetupResolver },
        children: [
            {
                path: '',
                children: [
                    {
                        path: '',
                        pathMatch: 'full',
                        redirectTo: '/home',
                    },
                    {
                        path: 'home',
                        loadChildren: () => import('./modules/home/home.module').then((m) => m.HomeModule),
                    },
                    {
                        path: 'tournaments',
                        loadChildren: () =>
                            import('./modules/tournament/tournament.module').then((m) => m.TournamentModule),
                    },
                    {
                        path: 'auth',
                        loadChildren: () => import('./modules/auth/auth.module').then((m) => m.AuthModule),
                    },
                    {
                        path: 'user',
                        loadChildren: () => import('./modules/user/user.module').then((m) => m.UserModule),
                    },
                    {
                        path: 'kids',
                        loadChildren: () => import('./modules/kids/kids.module').then((m) => m.KidsModule),
                    },
                    {
                        path: 'tennis10',
                        loadChildren: () => import('./modules/tennis10/tennis10.module').then((m) => m.Tennis10Module),
                    },
                    {
                        path: 'youth',
                        loadChildren: () => import('./modules/youth/youth.module').then((m) => m.YouthModule),
                    },
                    {
                        path: 'wheelchair',
                        loadChildren: () =>
                            import('./modules/wheelchair/wheelchair.module').then((m) => m.WheelchairModule),
                    },
                    {
                        path: 'professional',
                        loadChildren: () =>
                            import('./modules/professional/professional.module').then((m) => m.ProfessionalModule),
                    },
                    {
                        path: 'senior',
                        loadChildren: () => import('./modules/senior/senior.module').then((m) => m.SeniorModule),
                    },
                    {
                        path: 'classes',
                        loadChildren: () => import('./modules/classes/classes.module').then((m) => m.ClassesModule),
                    },
                    {
                        path: 'development',
                        loadChildren: () =>
                            import('./modules/development/development.module').then((m) => m.DevelopmentModule),
                    },
                    {
                        path: 'beachtennis',
                        loadChildren: () =>
                            import('./modules/beachtennis/beachtennis.module').then((m) => m.BeachtennisModule),
                    },
                    {
                        path: 'coachtraining',
                        loadChildren: () =>
                            import('./modules/coachtraining/coachtraining.module').then((m) => m.CoachtrainingModule),
                    },
                    {
                        path: 'arbitration',
                        loadChildren: () =>
                            import('./modules/arbitration/arbitration.module').then((m) => m.ArbitrationModule),
                    },
                    {
                        path: 'federation',
                        loadChildren: () =>
                            import('./modules/federation/federation.module').then((m) => m.FederationModule),
                    },
                    {
                        path: 'onbudsman',
                        loadChildren: () =>
                            import('./modules/onbudsman/onbudsman.module').then((m) => m.OnbudsmanModule),
                    },
                    {
                        path: 'entity',
                        loadChildren: () => import('./modules/entity/entity.module').then((m) => m.EntityModule),
                    },
                    {
                        path: 'videos',
                        loadChildren: () => import('./modules/videos/videos.module').then((m) => m.VideosModule),
                    },
                    {
                        path: 'institutional',
                        loadChildren: () =>
                            import('./modules/institutional/institutional.module').then((m) => m.InstitutionalModule),
                    },
                    {
                        path: 'faq',
                        loadChildren: () => import('./modules/faq/faq.module').then((m) => m.FaqModule),
                    },
                    {
                        path: 'contact',
                        loadChildren: () => import('./modules/contact/contact.module').then((m) => m.ContactModule),
                    },
                    {
                        path: 'news',
                        loadChildren: () => import('./modules/news/news.module').then((m) => m.NewsModule),
                    },
                    {
                        path: 'clubs',
                        loadChildren: () => import('./modules/clubs/clubs.module').then((m) => m.ClubsModule),
                    },
                    {
                        path: 'bananabowl',
                        loadChildren: () =>
                            import('./modules/bananabowl/bananabowl.module').then((m) => m.BananabowlModule),
                    },
                
                    {
                        path: 'rating',
                        loadChildren: () =>
                            import('./modules/rating-providers/rating-providers.module').then(
                                (m) => m.RatingProvidersModule
                            ),
                    },
                    { path: 'news/:postId', component: SharedDetailNewsComponent },
                    {
                        path: 'ranking',
                        loadChildren: () => import('./modules/ranking/ranking.module').then((m) => m.RankingModule),
                    },
                    {
                        path: 'privacy-policy',
                        loadChildren: () =>
                            import('./modules/privacy-policy/privacy-policy.module').then((m) => m.PrivacyPolicyModule),
                    },
                ],
            },

            { path: 'acesso-negado', component: AccessDeniedComponent },
            {
                path: 'acesso-revalidar-negado',
                component: AccessMailRevalidateComponent,
            },
            { path: 'nao-encontrado', component: NotFoundComponent },
            {
                path: 'policy-review',
                loadChildren: () =>
                    import('./modules/policy-review/policy-review.module').then((m) => m.PolicyReviewModule),
            },
            {
                path: 'courts',
                loadChildren: () =>
                    import('./modules/courts-internal/courts.module').then((m) => m.CourtsInternalModule),
            },
            {
                path: 'services',
                loadChildren: () => import('./modules/services/services.module').then((m) => m.ServicesModule),
            },
            {
                path: 'tournaments-central',
                loadChildren: () =>
                    import('./modules/tournament-central/tournament-central.module').then(
                        (m) => m.TournamentCentralModule
                    ),
            },
            {
                path: 'events',
                loadChildren: () => import('./modules/events/events.module').then((m) => m.EventsModule),
            },
        ],
    },
    {
        path: 'auth/oauth',
        pathMatch: 'full',
        component: OAuthComponent,
    },
    {
        path: 'redirect-token',
        component: RedirectTokenComponent,
    },
    {
        path: 'courts-dashboard',
        loadChildren: () => import('./modules/courts/courts.module').then((m) => m.CourtsModule),
    },

    { path: '**', redirectTo: '/nao-encontrado' },
];

@NgModule({
    imports: [RouterModule.forRoot(routes, { scrollPositionRestoration: `enabled` })],
    exports: [RouterModule],
})
export class AppRoutingModule {}
